// removed by extract-text-webpack-plugin
module.exports = {"calendar-select-default-modal":"calendar-select-default-modal","select-default-description":"select-default-description","team-items":"team-items","team-name":"team-name","calendar-items":"calendar-items","calendar-select-item":"calendar-select-item"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/calendar-select-default-modal/calendar-select-default-modal.style.sass
// module id = xBRd
// module chunks = 0